import React, { useState, useRef } from 'react';
import { Button, Space, Spin } from 'antd';
import { CameraOutlined, LoadingOutlined, RetweetOutlined } from '@ant-design/icons'; // Ikon untuk loading spinner
import Webcam from 'react-webcam';

const CameraComponent = ({ setCapturedImage }) => {
  const [isLoading, setIsLoading] = useState(false); // Status loading
  const [currentDevice, setCurrentDevice] = useState('user'); // Menyimpan perangkat (user/depan atau environment/belakang)
  const [isCameraOpen, setIsCameraOpen] = useState(true); // Status untuk menampilkan kamera atau tidak
  const webcamRef = useRef(null);

  // Fungsi untuk menangkap foto
  const capturePhoto = () => {
    const imageSrc = webcamRef.current.getScreenshot();
    setCapturedImage(imageSrc); // Menyampaikan hasil gambar ke parent
    setIsCameraOpen(false); // Menutup kamera setelah gambar diambil
  };

  // Fungsi untuk mengganti kamera
  const switchCamera = () => {
    setIsLoading(true); // Aktifkan indikator loading

    // Ganti perangkat kamera
    const newDevice = currentDevice === 'user' ? 'environment' : 'user';
    setCurrentDevice(newDevice);

    // Memulai perubahan kamera
    setTimeout(() => {
      if (webcamRef.current) {
        // Ubah konfigurasi `facingMode` untuk mengganti kamera
        webcamRef.current.videoConstraints = {
          facingMode: newDevice,
        };
      }
      setIsLoading(false); // Matikan indikator loading
    }, 500); // Penundaan untuk memberikan waktu agar kamera bisa berpindah
  };

  // Fungsi untuk membuka kamera kembali
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
      }}
    >
      {isLoading && (
        <Spin
          indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
          style={{ marginBottom: '20px' }}
        />
      )}

      {/* Webcam Component */}
      {isCameraOpen && (
        isLoading ? null : <Webcam
          audio={false}
          ref={webcamRef}
          screenshotFormat="image/jpeg"
          videoConstraints={{
            facingMode: currentDevice, // Menggunakan perangkat saat ini (user atau environment)
            zoom: 1, // Menetapkan zoom default ke 1x
          }}
          width="100%"
          height="auto"
          style={{
            borderRadius: '8px',
            boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
            marginBottom: '20px',
            transform: currentDevice === 'user' ? 'scaleX(-1)' : 'none', // Efek mirror hanya untuk kamera user
          }}
        />
      )}

      {/* Tombol untuk menangkap foto */}
      {isCameraOpen && (
        <Space>
          <Button onClick={capturePhoto} icon={<CameraOutlined />}>
            Ambil Foto
          </Button>

          <Button onClick={switchCamera} type="dashed" icon={<RetweetOutlined />}>
            Ganti Kamera
          </Button>
        </Space>
      )}
    </div>
  );
};

export default CameraComponent;
